
import jwt from 'jsonwebtoken'
import EventBus from '@/utils/eventBus'

export default class AuthService {
  constructor() {
    this.userId = null
  }

  setAuthToken(token, onUserLogin = false) {
    localStorage.setItem('token', token)
    EventBus.emitEvent(EventBus.EventTypes.authSessionUpdated)

    // Send out event for user session created
    if(onUserLogin) {
      if(this.hasAuthSession()) {
        EventBus.emitEvent(EventBus.EventTypes.userSessionUpdated)
      }
    }
  }

  getAuthToken() {
    return localStorage.getItem('token')
  }

  getUserId() {
    if(!this.hasAuthSession())
      return null
    return this.userId
  }

  hasAuthSession() {
    var authToken = this.getAuthToken()
    if(authToken == null)
      return false

    // Decode & check expiry
    try {
      var tokenInfo = jwt.decode(authToken)
      if(tokenInfo != null && tokenInfo.exp != null) {
        // Expired? Clear session too
        if (Date.now() >= tokenInfo.exp * 1000) {
          this.clearAuthSession()
          return false;
        }

        // Set the user id
        this.userId = tokenInfo.id
      }
    } catch(err) {
      // Error decoding token. Just return true (in case the JWT has changed for whatever reason...)
      // Server will handle invalid/expired tokens
      return true
    }

    // Just return true. Server will handle invalid/expired tokens
    return true
  }

  clearAuthSession() {
    localStorage.removeItem('token')
    this.userId = null

    EventBus.emitEvent(EventBus.EventTypes.authSessionUpdated)
    EventBus.emitEvent(EventBus.EventTypes.userSessionUpdated)
  }
}